module.exports = __webpack_public_path__ + "static/media/tr_imageW900_1.936ef4db.jpg";